import React, { Component } from "react"
import { IJobFilter } from "../../../models"
import strings from "../../../localization/strings"
import JobStatusSelection from "../../job/JobStatusSelection"
import { Toggle, SelectField, MenuItem } from "material-ui"
import DateRangeSelect from "../../common/DateRangeSelect"
import MultiClientChips from "../../clients/choose_client/MultiClientChips"
import AccountStore from "../../../stores/AccountStore"
import { grey700 } from "material-ui/styles/colors"
interface IProps {
    isClientJob?: boolean
    editFilterTemplate?: IJobFilter
    checkValidate?(isValidate: boolean): void
}
interface IState {
    filterData: IJobFilter
    errorStartDate: string
    errorEndDate: string
}

export default class AddJobsFilterTemplateDialogContainer extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            filterData: props.editFilterTemplate ?
                props.editFilterTemplate :
                {
                    Id: "",
                    Name: "",
                    Active: props.isClientJob ? null : true,
                    FilterOnlyFavorites: null,
                    JobStatusId: null,
                    JobSubStatusId: null,
                    JobType: null,
                    CurrentJob: false,
                    FilterByStartEndDate: false,
                    StartDateLocal: null,
                    EndDateLocal: null,
                    FilterByClientIds: []
                } as IJobFilter,
            errorStartDate: "",
            errorEndDate: ""
        }
    }

    componentDidMount() {
        this.checkValidate()
    }

    checkValidate() {
        let isValidate = true
        const { filterData } = this.state
        if (filterData.FilterByStartEndDate && (!filterData.StartDateLocal || !filterData.EndDateLocal)) {
            this.setState({
                errorStartDate: filterData.StartDateLocal ? "" : strings.required,
                errorEndDate: filterData.EndDateLocal ? "" : strings.required
            })
            isValidate = false
        }
        else {
            this.setState({ errorStartDate: "", errorEndDate: "" })
        }
        this.props.checkValidate(isValidate)
    }

    render() {
        const { filterData } = this.state
        return (
            <div>
                {!this.props.isClientJob &&
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <SelectField
                            data-intercom-target={"Jobs-Filter-Template-Select-ActiveStatus"}
                            floatingLabelText={strings.Active_Status}
                            value={filterData.Active}
                            onChange={(event, key, value) =>
                                this.setState({
                                    filterData: {
                                        ...filterData,
                                        Active: value,
                                        FilterOnlyFavorites: false
                                    }
                                })
                            }
                            style={{ width: 250 }}
                        >
                            <MenuItem value={true} primaryText={strings.Active} />
                            <MenuItem value={false} primaryText={strings.Inactive} />
                        </SelectField>
                        <Toggle
                            data-intercom-target={"Jobs-Filter-Template-Filter-Only-Favorites"}
                            label={strings.Filter_Only_Favorites}
                            toggled={filterData.FilterOnlyFavorites ? true : false}
                            style={{ width: 275 }}
                            onToggle={(e, value) => {
                                this.setState({ filterData: { ...filterData, FilterOnlyFavorites: value, Active: value ? null : true } })
                            }}
                        />
                    </div>
                }
                <JobStatusSelection
                    jobType={filterData.JobType === null ? strings.All : filterData.JobType}
                    statusId={filterData.JobStatusId}
                    subStatusId={filterData.JobSubStatusId}
                    onStatusChange={(data) => this.setState({
                        filterData: {
                            ...filterData,
                            JobStatusId: data.status ? data.status.Id : "",
                            JobSubStatusId: data.subStatus ? data.subStatus.Id : "",
                            JobType: (data.jobType === null || data.jobType === strings.All) ? null : Number(data.jobType)
                        }
                    })}
                />
                {(!this.props.isClientJob || AccountStore.getCRMEnabled()) &&
                    <div>
                        <Toggle
                            label={strings.Current_Job}
                            toggled={filterData.CurrentJob ? true : false}
                            style={{ width: 275, marginTop: 25 }}
                            onToggle={(e, value) => {
                                const currentJob = value
                                let filterByStartEndDate = filterData.FilterByStartEndDate
                                let startDate = filterData.StartDateLocal
                                let endDate = filterData.EndDateLocal
                                if (value) {
                                    filterByStartEndDate = false
                                    startDate = null
                                    endDate = null
                                }
                                this.setState({ filterData: { ...filterData, CurrentJob: currentJob, FilterByStartEndDate: filterByStartEndDate, StartDateLocal: startDate, EndDateLocal: endDate } })
                            }}
                        />
                        {AccountStore.getCRMEnabled() &&
                            <div style={{ height: 50, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                                <Toggle
                                    label={strings.Filter_by_Job_Start_End_Dates}
                                    toggled={filterData.FilterByStartEndDate}
                                    disabled={filterData.CurrentJob}
                                    style={{ width: 275 }}
                                    onToggle={(e, value) => {
                                        this.setState({ filterData: { ...filterData, FilterByStartEndDate: value, StartDateLocal: value ? filterData.StartDateLocal : null, EndDateLocal: value ? filterData.EndDateLocal : null } }, () => this.checkValidate())
                                    }}
                                />
                                {filterData.FilterByStartEndDate &&
                                    <DateRangeSelect
                                        startDate={filterData.StartDateLocal}
                                        endDate={filterData.EndDateLocal}
                                        handleChange={(startDate, endDate, isValid) =>
                                            isValid &&
                                            this.setState({ filterData: { ...filterData, StartDateLocal: startDate, EndDateLocal: endDate } }, () => this.checkValidate())
                                        }
                                        sameDatesAllowed
                                        errorStartDate={this.state.errorStartDate}
                                        errorEndDate={this.state.errorEndDate}
                                    />
                                }
                            </div>
                        }
                    </div>
                }
                {AccountStore.getClientsEnabled() && !this.props.isClientJob &&
                    <div style={{ marginTop: 25 }}>
                        <MultiClientChips
                            label={strings.Filter_By_Clients}
                            labelColor={grey700}
                            selectedClientIds={filterData.FilterByClientIds || []}
                            handleChange={clients =>
                                this.setState({ filterData: { ...filterData, FilterByClientIds: clients && clients.length ? clients.map(i => i.Id) : null } })
                            }
                        />
                    </div>
                }
            </div>
        )
    }
}
